import { z } from 'zod';
import { optionalText, optionalUrl } from './common.js';

/** ISO-4217, upper case. Kept as a string so new currencies need no deploy. */
export const currencySchema = z
  .string()
  .trim()
  .toUpperCase()
  .length(3, 'Use a 3-letter ISO currency code');

export const updateOrganizationSchema = z.object({
  name: z.string().trim().min(2).max(120).optional(),
  currency: currencySchema.optional(),
  timezone: optionalText(64),
  website: optionalUrl(),
});
export type UpdateOrganizationInput = z.infer<typeof updateOrganizationSchema>;
